import * as React from "react";
import Component from "../../AbstractComponent";
import { TabsComponent } from "./TabsComponent";
import { connect } from "react-redux";
// import { BackendBalanceComponent } from "../../Partials/Balance/BackendBalanceComponent";

import Card from '@material-ui/core/Card';

class AgencyBalance extends Component {
  constructor(public props) {
    super(props);
  }

  public render() {
    return (
      <div className="state-app">
        <div className={`box box-full component-finance full-width has-general-page-header with-tabs ${this.props.app?.settings?.user?.launchPanelState ? "with-launchpanel" : ""}`}>
          <div className="component-header no-paddings">
            <h1>{this.trans("title-finance")}</h1>
            <TabsComponent
              activeTab={4}
              {...this.props}
            />
          </div>
          <div className="component-wrapper no-margin-top">
            <Card className="card no-padding">
            </Card>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(
    AgencyBalance
);
